import React, { Fragment, useEffect, useState } from 'react';
import { CallApiGet } from '../apicalls/calls.js';
import Linea from './Graficas/linea.jsx';

export default function inicio() {
  //console.log("localState", window.localStorage.getItem('usuario'));
  const UsuarioS = JSON.parse(window.localStorage.getItem('usuario'));
  const [state, Setstate] = useState({
    ganadores: [],
    tabla: {
      labels: [],
      datasets: []
    }
  });

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    return (() => {
      //Test de la tabla
      $("#backdrop").hide();

    })
  }, [state]);

  async function fetchData() {
    $("#backdrop").show();
    //console.log(UsuarioS)
    var params = { tipo_usuario: UsuarioS.user.tipo_usuario, id_usuario: UsuarioS.user.id }
    //console.log("Token", UsuarioS.access_token);
    const Call = await CallApiGet('getDashboard', params, UsuarioS.access_token);
    //console.log("Call", Call);
    if (Call.status != 200) {
      window.Swal.fire({
        icon: 'error',
        title: 'Error',
        text: Call.error.message,
      });
    } else {
      Setstate({
        ganadores: Call.success.sorteos.ganadores,
        tabla: Call.success.sorteos.grafica
      });
    }
  }
  return (
    <div className="container-fluid" >
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0 text-gray-800">Inicio</h1>
      </div>

      {UsuarioS.user.tipo_usuario == 1 && (
        <div className='row'>
          <div className="col-xl-12 col-lg-12">
            <div className="card shadow mb-4">
              <div
                className="card-header py-3 d-flex flex-row align-items-center justify-content-between" style={{ color: "#E6453B" }}>
                <h6 className="m-0 font-weight-bold">Sorteo Activo</h6>
              </div>
              <div className="card-body">
                <div className="chart-area">
                  <Linea Data={state.tabla} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className='row'>
        <div className="col-xl-12 col-lg-12">
          <div className="card shadow mb-4">
            <div
              className="card-header py-3 d-flex flex-row align-items-center justify-content-between" style={{ color: "#E6453B" }}>
              <h6 className="m-0 font-weight-bold">Números ganadores de los ultimos 5 sorteos</h6>
            </div>
            <div className="card-body">
              <div className='table-responsive'>
                <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                  <thead>
                    <tr>
                      <th rowSpan={2}>Sorteo</th>
                      <th rowSpan={2}>Fecha</th>
                      <th rowSpan={2}>Tipo</th>
                      <th rowSpan={2}>Número</th>
                      <th colSpan={2} className={'text-center'}>Ganadores</th>
                    </tr>
                    <tr>
                      <th>Ganador</th>
                      <th>Cantidad</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.ganadores.length == 0 && (
                      <tr className='text-center'>
                        <td colSpan={6}>No hay registros en la tabla</td>
                      </tr>
                    )}
                    {state.ganadores && state.ganadores.map((item, key) => (
                      <Fragment key={key}>
                        <tr>
                          <td rowSpan={3 + item.usuarios1.length + item.usuarios2.length}>{item.nombre}</td>
                          <td rowSpan={3 + item.usuarios1.length + item.usuarios2.length}>{window.moment(item.fecha_inicio).locale('es-mx').format('L')}</td>
                        </tr>
                        <tr>
                          <td rowSpan={1 + item.usuarios1.length}>Primer Premio</td>
                          <td rowSpan={1 + item.usuarios1.length}>{item.numero1}</td>
                        </tr>
                        {item.usuarios1.map((item1, key1) => (
                          <tr key={key1}>
                            <td>{item1.nombre}</td>
                            <td>{item1.cantidad}</td>
                          </tr>
                        ))}
                        {item.usuarios2.length > 0 ? <tr>
                          <td rowSpan={1 + item.usuarios2.length}>Segundo Premio</td>
                          <td rowSpan={1 + item.usuarios2.length}>{item.numero2}</td>
                        </tr> : <tr></tr>}
                        {item.usuarios2.map((item2, key2) => (
                          <tr key={key2}>
                            <td>{item2.nombre}</td>
                            <td>{item2.cantidad}</td>
                          </tr>
                        ))}
                        {/* {item.usuarios2.length == 0 && (
                          <tr>
                            <td>{'si registro'}</td>
                            <td>{'sin registros'}</td>
                          </tr>
                        )} */}
                      </Fragment>
                    ))}

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
